export const excludedAttributes = ["system-subscription-mgmt", "access", "ezero-number", "customer-id"];


// WEBPACK FOOTER //
// ./src/accounts/account-product-details/account-api-product-details/components/AccountProductsConstants.js